import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';
import APPROVAL_LIKELIHOOD from '../definitions/ApprovalLikelihood';
import APPROVAL_LIKELIHOOD_COLOURS from '../definitions/ApprovalLikelihoodColours';


function ApprovalLikelihoodPill({ approvalLikelihood, className }) {
    if (!Object.values(APPROVAL_LIKELIHOOD).includes(approvalLikelihood)) {
        return null;
    }

    return (
        <Container
            className={classNames(className,
                'rh-display-flex rh-text-align-center rh-justify-content-center rh-text-2xs rh-mb-0_5 rh-p-0_5 rh-border-radius-8px')}
            approvalLikelihood={approvalLikelihood}
            data-test-name="approval-likelihood-pill"
        >
            <FormattedMessage
                id="cardfinder.bnb.approval-likelihood"
                defaultMessage={`<strong>Approval likelihood: <bolder>{approvalLikelihood, select,
                    good {GOOD}
                    fair {FAIR}
                    poor {POOR}
                    other {N/A}
                    }</bolder></strong>`}
                values={{
                    ...DefaultIntlFormatValues,
                    approvalLikelihood: approvalLikelihood,
                    // eslint-disable-next-line react/jsx-one-expression-per-line
                    bolder: str => <span className="weight-bold">{str}</span>,
                }}
            />
        </Container>
    );
}

ApprovalLikelihoodPill.propTypes = {
    approvalLikelihood: PropTypes.oneOf(Object.values(APPROVAL_LIKELIHOOD)),
    className: PropTypes.string,
};


const Container = styled.div`
    ${({ approvalLikelihood }) => `
        background-color: ${APPROVAL_LIKELIHOOD_COLOURS[approvalLikelihood]?.backgroundColour};
    `};
`;


export default ApprovalLikelihoodPill;
